import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

function TrackingChannels({ channels = [], selectedChannels = [], setSelectedChannels = () => {}, type = '' }) {
  const [channelList, setChannelList] = useState(
    channels.map((channel) => {
      const formatChannels = {
        EMAIL: { name: 'Correo', selected: selectedChannels.includes('EMAIL'), request: 'EMAIL' },
        WHATSAPP: { name: 'WhatsApp', selected: selectedChannels.includes('WHATSAPP'), request: 'WHATSAPP' },
        WEBHOOK: { name: 'Webhook', selected: selectedChannels.includes('WEBHOOK'), request: 'WEBHOOK' },
      };
      return formatChannels[channel];
    })
  );
  useEffect(() => {
    setSelectedChannels(channelList.filter((item) => item.selected).map((item) => item.request));
  }, [channelList]);
  return (
    <>
      <Form.Label>{`${type === 'internal' ? '2.' : '5.'} Selecciona los canales por los cuales deseas ${
        type === 'internal' ? 'recibir' : 'enviar'
      } las notificaciones:`}</Form.Label>
      {channelList.map((channel, index) => (
        <div key={index} className="ms-2">
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={channel.selected}
            onClick={() => {
              setChannelList(
                channelList.map((elem) => {
                  if (channel.name === elem.name) {
                    elem.selected = !channel.selected;
                  }
                  return elem;
                })
              );
              //   setErrors((prev) => {
              //     return { ...prev, deliveryType: '' };
              //   });
            }}
          />
          <label className="form-label">
            {channel.name}
            {channel.request !== 'EMAIL' && <span className="text-small text-secondary ps-2">(proximamente)</span>}
          </label>
        </div>
      ))}
    </>
  );
}

export default TrackingChannels;
